import {
  SemanticEssentialColor,
  SemanticTextColor,
} from '@spotify-internal/encore-web';
import { ApprovalStatus } from '@hooks/useAlbumInfo/types';

export function approvalStatusColor(
  status?: ApprovalStatus,
): SemanticTextColor {
  switch (status) {
    case ApprovalStatus.APPROVED:
      return 'textPositive';
    case ApprovalStatus.DECLINED:
    case ApprovalStatus.REMOVED:
      return 'textNegative';
    case ApprovalStatus.PARTIALLY_APPROVED:
    case ApprovalStatus.NEEDS_APPROVAL:
      return 'textWarning';
    case ApprovalStatus.EXPIRED:
    case ApprovalStatus.NOT_REQUIRED:
    case ApprovalStatus.DEFAULT_APPROVED:
    default:
      return 'textSubdued';
  }
}

export function approvalStatusIndicatorColor(
  status?: ApprovalStatus,
): SemanticEssentialColor {
  switch (status) {
    case ApprovalStatus.APPROVED:
      return 'essentialPositive';
    case ApprovalStatus.DECLINED:
    case ApprovalStatus.REMOVED:
      return 'essentialNegative';
    case ApprovalStatus.PARTIALLY_APPROVED:
    case ApprovalStatus.NEEDS_APPROVAL:
      return 'essentialWarning';
    case ApprovalStatus.EXPIRED:
    case ApprovalStatus.NOT_REQUIRED:
    case ApprovalStatus.DEFAULT_APPROVED:
    default:
      return 'essentialSubdued';
  }
}
